import { styled } from "styled-components";
import { SolutionHistoryHeader } from "../../history/style";

export const MileagePopupWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 13px;
  padding: 40px 15px;
  box-sizing: border-box;
`;

export const MileageWrapper = styled(MileagePopupWrapper)`
  width: 514px;
  z-index: 1000;
  min-height: 322px;
`;

export const MileageHeader = styled(SolutionHistoryHeader)`
  > .right {
    display: flex;
    gap: 10px;
    align-items: center;

    > .name {
      display: flex;
      gap: 4px;
      align-items: center;
      font-family: Pretendard;
      font-weight: 400;
      font-size: 15px;

      > span {
        font-family: Pretendard;
        font-weight: 600;
        font-size: 20px;
      }
    }

    > .button {
      width: 86px;
      height: 31px;
      border-radius: 8px;
      background: #6436e7;
      font-family: Pretendard;
      font-weight: 600;
      font-size: 15px;
      line-height: 31px;
      text-align: center;
      color: #fff;
      cursor: pointer;
    }

    > img {
      width: 13.74px;
      height: 13.74px;
    }
  }

  img {
    cursor: pointer;
    margin-right: 10px;
  }
`;

export const SearchMemberWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const SearchListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #e5e5e5;
  border-radius: 15px;
  padding: 10px 15px;
  gap: 5px;
  height: 128px;
  overflow-y: auto;
  scrollbar-width: none;

  > .no-data {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 14.67px;
    line-height: 27px;
    text-align: center;
  }

  > .item {
    min-height: 37px;
    border-radius: 14.71px;
    padding: 5px 16px;
    background: #ffffff;
    box-sizing: border-box;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 14.67px;
    line-height: 27px;
    cursor: pointer;
  }
`;

export const MileageMemberWrapper = styled.div`
  position: relative;

  > .header {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0%;

    > .point {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      flex-shrink: 0;

      > img {
        cursor: pointer;
      }
    }
  }
`;

export const MileageButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  position: relative;
  bottom: -20px;

  > .button {
    flex: 1;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 15px;
    text-align: center;
    height: 48px;
    border-radius: 8px;
    line-height: 48px;
    color: #6436e7;
    cursor: pointer;

    &.purple {
      background: #6436e7;
      color: #fff;
    }

    &.gray {
      background: #bebebe;
      color: #fff;
    }
  }
`;

export const MileagePayMentWrapper = styled.div`
  height: 120px;
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  > .pay-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 40px;
    border-bottom: 1.53px dashed #d9d9d9;

    > .name {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 17px;
      line-height: 100%;
      letter-spacing: 0%;
    }

    > input {
      outline: none;
      width: 120px;
      height: 34px;
      border-radius: 9.78px;
      border: 1px solid #e5e5e5;
      font-family: Pretendard;
      font-weight: 500;
      font-size: 14.67px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;
    }
  }

  > .result-wrapper {
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .name {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
    }

    > .value {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: right;
    }
  }
`;

export const MileageHistoryWrapper = styled(MileagePopupWrapper)`
  width: 514px;
  height: 461px;
  z-index: 1001;
  border-radius: 13px;
  min-height: 322px;
`;

export const MileageHistoryTable = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 100%;
  margin-bottom: 25px;

  > .header {
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1.53px solid #b0b0b0;

    > .item {
      font-family: Pretendard;
      font-weight: 500;
      font-size: 11px;
      text-align: center;
      flex: 1;
    }
    > .back {
      width: 40px;
    }
  }

  > .body {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 17px;
    height: 212px;

    > .no-data {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 12px;
      text-align: center;
    }
  }
`;

export const MileageHistoryItemWrapper = styled.div`
  display: flex;
  align-items: center;

  > .item {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    flex: 1;
  }

  > .back {
    font-family: Pretendard;
    font-weight: 600;
    font-size: 10px;
    text-align: left;
    text-decoration: underline;
    text-decoration-style: solid;
    color: #ff0000;
    width: 40px;
    cursor: pointer;
    text-align: center;
  }
`;

export const MileagePageWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;

  > .page {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
  }

  > img {
    cursor: pointer;
  }
`;
